import type { ReactNode } from "react";
import LoadingState from "../LoadingState";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { ServiceUnavailableBanner } from "../ServiceUnavailableBanner/ServiceUnavailableBanner";

/**
 * Blocks rendering of children until the initial feature-flags fetch
 * resolves. Sits inside `<FeatureFlagsProvider>` and ensures protected
 * routes do not render before flag state is known — which would otherwise
 * cause flag-gated affordances to flash off-then-on.
 *
 * In `DISABLE_AUTH=true` mode the hook reports `isLoading=false`
 * immediately, so this gate is a no-op in dev.
 */
export default function FeatureFlagsGate({ children }: { children: ReactNode }) {
  const { isLoading } = useFeatureFlags();

  if (isLoading) {
    return (
      <>
        <ServiceUnavailableBanner />
        <LoadingState fullscreen message="Loading feature flags..." />
      </>
    );
  }

  return <>{children}</>;
}
